import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    processingFiles: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',

      '& .MuiTypography-body1': {
        color: '#676767',
        fontWeight: 600,
        fontSize: '1.2rem',
      },

      '& span': {
        fontWeight: 600,
        fontSize: '1.2rem',
        marginRight: '0.5rem',
        fontFamily: 'Source Sans Pro, sans-serif',
      },

      '& > div:last-child': {
        boxShadow:
          '0px 1px 2px rgba(0, 0, 0, 0.3), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)',
        borderRadius: '5px',
      },

      '& .MuiTypography-body2': {
        fontWeight: 500,
        fontSize: '1.6rem',
        padding: '2.5rem',

        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
      },

      '& .MuiLinearProgress-root': {
        height: '6px',
        borderRadius: '10px',

        '&.MuiLinearProgress-colorPrimary': {
          backgroundColor: 'transparent',
        },

        '& .MuiLinearProgress-bar': {
          borderRadius: '10px',
        },

        '& .MuiLinearProgress-bar1Indeterminate': {
          animationDuration: 2.3 * 1000,
        },
        '& .MuiLinearProgress-bar2Indeterminate': {
          animation: 'none',
        },
      },
    },
    borderCompleted: {
      border: `3px solid ${theme.palette.primary.main}`,
    },
    textColorCompleted: {
      '&.MuiTypography-body1': {
        color: theme.palette.secondary.main,
      },
    },
  }),
)
